<template>
    <div>
       <md-empty-state
      md-icon="error"
      md-label="Error 404"
      md-description="The request page was not found.">
    </md-empty-state>
    </div>
</template>

<script>
  export default {
    name: 'page_notfound'
  }
</script>
